import type { SipPhone } from "~/services/calling/sipPhone";

let activeSipPhone: SipPhone | null = null;

export const setActiveSipPhone = (phone: SipPhone | null) => {
  activeSipPhone = phone;
};

export const disconnectActiveSipTransport = () => {
  activeSipPhone?.disconnectTransportSync();
};

export const stopActiveSipPhone = async () => {
  if (!activeSipPhone) return;

  await Promise.race([
    activeSipPhone.stop(),
    new Promise<void>((resolve) => {
      window.setTimeout(resolve, 3000);
    }),
  ]);
};
